export default "__VITE_ASSET__Cv$9ffyv__"